export default __webpack_public_path__ + "static/media/img1.db55d1f3.png";